(function () {
    'use strict';

    angular
        .module('manage-workshops')
        .config(ManageWorkshopsRoute);

    ManageWorkshopsRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function ManageWorkshopsRoute ($stateProvider) {
        $stateProvider
            .state('root.manageWorkshops', {
                abstract: true,
                url: '/manage-workshops',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.manageWorkshops.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/workshops/manageWorkshops/list/list.html',
                    }
                }
            })
    }
})();